import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspaceDeveloperApi as r } from "@maat/api-main";
//#region src/workspaceDeveloper/useSignDeveloperTermsMutation.ts
var i = () => {
	let i = n();
	return t({
		retry: !1,
		mutationFn: (e) => r.signTerms(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.status() }), i.invalidateQueries({ queryKey: e.terms() });
		}
	});
};
//#endregion
export { i as useSignDeveloperTermsMutation };
